const iframes = document.querySelectorAll('iframe, #video');

if(iframes != null){
    const fix = ()=>{
        iframes.forEach(item => {
            const i_height = item.offsetWidth * 0.5625;
            item.style.height = `${i_height}px`;
        });
    }
    setTimeout(()=>{
        fix();
    }, 100);
    window.addEventListener('resize',
        _.debounce(() => {
            fix();
        }, 500)
    );
}